import { useEffect } from 'react';
import { useApolloClient } from '@apollo/client';
import { useUser } from '@luigiclaudio/ga-auth-theme';
import useAnalytics from '../../services/useAnalytics';
import { createAcquisitionTracker } from '../../../shared/newsletterAnalytics.cjs';
import {
    NEWSLETTER_PREFERENCES,
    SET_NEWSLETTER_PREFERENCE,
} from '../../services/newsletterOperations';

const attempted = new Set();

// Only a durable registration opt-in may be retried automatically on a confirmed
// visit. No account metadata or subscription tier is used as permission.
const RegistrationNewsletterSync = () => {
    const [user] = useUser();
    const client = useApolloClient();
    const track = useAnalytics();
    useEffect(() => {
        if (!user?.id || attempted.has(user.id)) return;
        attempted.add(user.id);
        const run = async () => {
            const { data } = await client.query({
                query: NEWSLETTER_PREFERENCES,
                variables: { registrationOnly: true },
                fetchPolicy: 'network-only',
            });
            const state = data.newsletterPreferences;
            if (
                state.error ||
                state.source !== 'registration' ||
                !state.syncPending ||
                state.intent !== 'subscribe'
            )
                return;
            const tracker = createAcquisitionTracker(track, 'registration', 'signup_footnote');
            tracker.begin();
            try {
                const response = await client.mutate({
                    mutation: SET_NEWSLETTER_PREFERENCE,
                    variables: {
                        action: 'RETRY',
                        requestId: window.crypto.randomUUID(),
                        expectedRevision: state.revision,
                    },
                });
                const result = response.data.setNewsletterPreference;
                tracker.settle(
                    result.result === 'accepted',
                    result.providerStatus,
                    true,
                    result.error,
                );
            } catch {
                tracker.settle(false, 'unknown', false, 'network');
            }
        };
        run().catch(() => {});
    }, [user?.id]);
    return null;
};

export default RegistrationNewsletterSync;
